"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Separator = _ref => {
  let {
    vertical,
    className,
    margin,
    thickMobile,
    noMargin,
    mobileOnly,
    ...props
  } = _ref;
  const classes = (0, _classnames.default)({
    "arc3-vertical-divider": vertical,
    "--divider-margin": margin,
    "--thick-mobile": thickMobile,
    "arc3-no-margin": noMargin,
    "arc3-hide-for-medium-up": mobileOnly
  }, className);
  if (vertical) return /*#__PURE__*/_react.default.createElement("span", {
    className: classes
  });
  return /*#__PURE__*/_react.default.createElement("hr", _extends({
    className: classes
  }, props));
};
exports.Separator = Separator;
Separator.propTypes = {
  /** Optional custom CSS classes */
  className: _propTypes.default.string,
  /** Use a vertical divider instead of a horizontal divider */
  vertical: _propTypes.default.bool,
  /** Add an extra large margin to the top and bottom - horizontal only */
  margin: _propTypes.default.bool,
  /** remove the default margin */
  noMargin: _propTypes.default.bool,
  /** hide for medium up */
  mobileOnly: _propTypes.default.bool,
  /** Make bolder in mobile view only - horizontal only */
  thickMobile: _propTypes.default.bool
};